import React from 'react';
import UsagePieChart from './UsagePieChart';

interface UsageChartProps {
  data: Record<string, number>;
  title: string;
  isCurrency?: boolean;
}

const UsageChart: React.FC<UsageChartProps> = ({ data, title, isCurrency }) => {
  const calculateTotal = (data: Record<string, number>): number => {
    return Object.values(data).reduce((sum, value) => sum + value, 0);
  };

  const total = calculateTotal(data);
  const formattedTotal = isCurrency
    ? `$${total.toFixed(2)}`
    : total.toLocaleString();

  if (Object.keys(data).length === 0 || total === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-4 bg-neutral-100 dark:bg-neutral-700/30 rounded-lg">
        <h3 className="text-sm font-medium mb-2">{title}</h3>
        <p className="text-xs text-gray-500 dark:text-gray-400">No data available</p>
        <p className="text-sm font-semibold mt-2">{isCurrency ? '$0.00' : '0'}</p>
      </div>
    );
  }

  return (
    <div>
      <UsagePieChart data={data} title={title} isCurrency={isCurrency}/>
      <p className="mt-2 text-sm font-semibold">{formattedTotal}</p>
    </div>
  );
};

export default UsageChart;